import styled, { CSSProperties, css } from 'styled-components';
import { Position } from '../../Drawer/types/Drawer.types';

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 8px;
  right: calc(-44px - 8px);
`;

export const DrawerContainer = styled.div`
  [class*='Drawerstyles__DrawerContent'] {
    top: 4.5rem;

    @media (min-width: 768px) {
      top: 4.75rem;
    }
  }
`;

export const MainNavigationContainer = styled.div<{
  position: Position;
  backgroundColor?: CSSProperties['backgroundColor'];
}>`
  padding: 2rem 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;

  .main-nav-items {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .top-bar-nav-items {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-right: 1rem;

    [class*='Interactionstyle__Interaction-sc'] {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
`;

export const MainNavigationItem = styled.li<{ isActive: boolean }>`
  * {
    ${props =>
      props.isActive &&
      css`
        border-bottom: 2px #e60000 solid;
        font-weight: 700;
        width: fit-content;
      `}
  }
`;
